import Vue from 'vue'
import AlertWalkie from './Walkie.vue' //引入刚才写的弹框组件
import store from '../../store/index'

// 返回一个“扩展实例构造器”
const AlertBox = Vue.extend(AlertWalkie)

AlertWalkie.install = function(data) {
  let instance = new AlertBox({
    data
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    store.commit('walkieShow', true)
    // console.log(store,data.show,"data.show")
    instance.show = data.show
    // show 和弹窗组件里的show对应，用于控制显隐
  })
}

export default AlertWalkie
